var _class, _ScaleSurveyEditionFormComponent;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from "@ember/object";
import ForcJournalEventBasedComponent, { ForcModelPojo, Payload } from "core/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import isChangesetValid from "core/utils/is-changeset-valid";
import { validateNumber, validatePresence } from "ember-changeset-validations/validators";
import { ValidatorAction, ValidatorMap } from "ember-changeset/types";
import { lookupValidator } from "validated-changeset";
/**
 * This class is here to help to build some "scale survey" form like FAST, QIDS or YMRS.
 * It works with a JE containing an array of items and a total.
 * But you can override some methods to work with a flatten JE with properties.
 */
let ScaleSurveyEditionFormComponent = (_class = (_ScaleSurveyEditionFormComponent = class ScaleSurveyEditionFormComponent extends ForcJournalEventBasedComponent {
  constructor(...args) {
    super(...args);
    /// PROPERTIES
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
    _defineProperty(this, "journalEventProperties", ["occurredAt", "total", "items", ...this.questionIds]);
    _defineProperty(this, "validator", obj => {
      return lookupValidator(this.currentValidations)(obj);
    });
  }
  get validationNames() {
    return "Le score";
  }
  get numberOfItems() {
    throw `'numberOfItems' is not provided for the class'${this.constructor.name}'.`;
  }
  get maximalScore() {
    throw `'maximalScore' is not provided for the class'${this.constructor.name}'.`;
  }

  /**
   * The payload will either be a changeset (when template refreshes),
   * or a POJO (when the form is saved).
   *
   * So use the 'get' function from '@ember/object' to access the payload values.
   */
  _computeScore(_payload) {
    throw `'_computeScore()' is not implemented for the class '${this.constructor.name}'.`;
  }
  get questionIds() {
    const attributes = [];
    for (let i = 0; i < this.numberOfItems; i++) {
      attributes.push(i.toString());
    }
    return attributes;
  }
  get surveyValidations() {
    return this.questionIds.reduce((validations, index) => {
      validations[index] = validatePresence({
        presence: true,
        description: this._getValidationName(index)
      });
      return validations;
    }, {});
  }
  get totalValidations() {
    return {
      total: [validatePresence({
        presence: true,
        description: "Le total"
      }), validateNumber({
        integer: true,
        lte: this.maximalScore,
        positive: true,
        description: "Le total"
      })]
    };
  }
  get validations() {
    return Object.assign({}, this.surveyValidations, this.totalValidations);
  }
  get currentValidations() {
    return this.changeset.get("isTotalScoreFilled") ? this.totalValidations : this.surveyValidations;
  }
  get score() {
    return this._computeScore(this.changeset);
  }
  get isChangesetValid() {
    return isChangesetValid(this.changeset, this.currentValidations);
  }

  /// EVENTS

  onTabButtonClicked(type) {
    this.changeset.set("isTotalScoreFilled", type === "second");
  }

  /// HOOKS

  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isEditMode) {
      // Select the second tab only if the total has been set and not the other properties.
      model.isTotalScoreFilled = model.total != null && !model.items?.length;

      // Inject the items array properties into our model
      this.questionIds.forEach(index => {
        model[index] = model.items[index];
      });
    } else {
      model.occurredAt = new Date();
    }
    return model;
  }
  computePayload() {
    const payload = super.computePayload();
    if (!this.model.isTotalScoreFilled) {
      // If the total is not given, compute it.
      payload.total = this._computeScore(payload).number;
      // Save the answered items
      payload.items = this.questionIds.map(index => payload[index]);
    } else {
      // If the total is given we don't store the items.
      payload.items = [];
    }

    // Remove the question item from the payload
    this.questionIds.forEach(index => delete payload[index]);
    return payload;
  }

  /// PRIVATE

  _getValidationName(index) {
    if (typeof this.validationNames === "string" || this.validationNames instanceof String) {
      return this.validationNames;
    } else if (Array.isArray(this.validationNames)) {
      return this.validationNames[index];
    }
    throw `The 'validationNames' should be a 'string' or an 'array of string'.`;
  }
}, _defineProperty(_ScaleSurveyEditionFormComponent, "forcDisplayName", "Not provided"), _defineProperty(_ScaleSurveyEditionFormComponent, "fullComponentId", "Not provided"), _ScaleSurveyEditionFormComponent), _applyDecoratedDescriptor(_class.prototype, "onTabButtonClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTabButtonClicked"), _class.prototype), _class);
export { ScaleSurveyEditionFormComponent as default };